import React, { useEffect } from 'react'

import axios from 'axios'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { validateToken } from './authActions'
import { Navigate } from 'react-router'

function AuthOrApp({ auth, validateToken, component }) {
    useEffect(() => {
        if (auth.user) {
            validateToken(auth.user.token)
        }
    }, [])

    const { user, validToken } = auth

    if (user && validToken) {
        axios.defaults.headers.common['Authorization'] = user.token
        return component
    } else if (!user && !validToken) {
        return <Navigate to='/' />
    } else {
        return false
    }
}

const mapStateToProps = (state) => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({ validateToken }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(AuthOrApp)